module.exports = __webpack_public_path__ + "img/sb-fx.08d239cc.svg";